// extracted by mini-css-extract-plugin
module.exports = {"dashboards":"style_dashboards__3vDdW","header":"style_header__wVuyd","printOnly":"style_printOnly__399ge"};